import queryString from 'query-string';

export default function getQueryStringLanguage() {
  const { lng = 'en' } = queryString.parse(window.location.search);

  return `?lng=${lng}`;
}
